<template lang="pug">
#staff-tab
  b-table(
    :data="staffMembers"
    :current-page="pagination.page"
    :per-page="pagination.per"
    :total="pagination.total"
    @click="open"
    @dragstart="dragstart"
    @dragover="dragover"
    @dragleave="dragleave"
    @drop="drop"
    @page-change="getPage"
    draggable
    hoverable
    backend-pagination
    paginated
  )
    template(slot-scope="props")
      b-table-column(width="25")
        b-icon.drag-icon.has-text-grey-light(icon="drag-vertical")
      b-table-column(label="Name") {{ props.row.full_name }}
      b-table-column(label="Title")
        small(v-if="props.row.title") {{ props.row.title }}
        small.has-text-grey-light(v-else) NA
      b-table-column(label="Email")
        small(v-if="props.row.email") {{ props.row.email }}
        small.has-text-grey-light(v-else) NA
      b-table-column(label="Bio")
        small(v-if="props.row.bio") {{ props.row.bio | truncate(75) }}
        small.has-text-grey-light(v-else) NA
</template>

<script>
import { mapGetters } from 'vuex';
import StaffMemberForm from '@/components/form/StaffMemberForm';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'staff-members-tab',
  computed: {
    ...mapGetters({
      filters: getters.GET_MINISTRY_FILTERS,
      refresh: getters.GET_MINISTRY_REFRESH,
      staffMembers: getters.GET_STAFF_MEMBERS,
    }),
  },
  created() {
    this.getPage(1);
  },
  data() {
    return {
      dragging: null,
      settings: {
        loading: false,
      },
      pagination: {
        page: 1,
        per: 12,
        total: 0,
      },
    };
  },
  methods: {
    dragstart(payload) {
      this.dragging = payload.row;
      payload.event.dataTransfer.effectAllowed = 'copy';
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy';
      payload.event.target.closest('tr').classList.add('is-selected');
      payload.event.preventDefault();
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      payload.event.preventDefault();
    },
    async drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      this.$store.commit(mutations.INSERT_STAFF_MEMBER, {
        index: payload.index,
        val: this.dragging,
      });
      const saveStaffMembers = [];
      this.staffMembers.forEach(staff => saveStaffMembers.push(this.saveStaffMember(staff)));
      await Promise.all(saveStaffMembers);
      this.$store.commit(mutations.SET_APP_SNACKBAR, {
        type: 'is-success',
        message: 'Sort order updated',
      });
    },
    async getPage(page) {
      this.settings.loading = true;
      this.pagination.page = page;
      const payload = { page };
      if (this.filters.query) {
        payload.query = this.filters.query;
      }
      await this.$store.dispatch(actions.DO_GET_STAFF_MEMBERS, payload);
      setTimeout(() => {
        this.settings.loading = false;
        this.$store.commit(mutations.SET_MINISTRY_REFRESH, false);
      }, 250);
    },
    async open(staffMember) {
      await this.$store.dispatch(actions.DO_GET_STAFF_MEMBER, {
        id: staffMember.id,
        zoom: 'profile_image',
      });
      this.$buefy.modal.open({
        parent: this,
        component: StaffMemberForm,
        hasModalCard: true,
      });
    },
    async saveStaffMember(staffMember) {
      const index = _.findIndex(this.staffMembers, { id: staffMember.id });
      if (index >= 0) {
        await this.$store.dispatch(actions.DO_UPDATE_STAFF_MEMBER, {
          id: staffMember.id,
          sort_order: index,
          zoom: 'profile_image',
        });
      }
    },
  },
  watch: {
    refresh(val) {
      if (val) this.getPage(1);
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/StaffMembersTab.vue